import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";
import { useUserActiveOrganization } from "../user/useUserActiveOrganization";

export const STANDING_OFFERS = gql(`
  query standingOffers($organizationSlug: String!) {
    organization(organizationSlug: $organizationSlug) {
      ... on Organization {
        __typename
        id
        standingOffers {
          __typename
          id
          name
          message
          createdAt
          status
          app {
            __typename
            id
            displayName
            pictureUrl
          }
          payment {
            __typename
            monthlyPriceUSD
            trialDays
          }
        }
      }
    }
  }
`);

export function useStandingOffers() {
  const { activeOrganization } = useUserActiveOrganization();

  const { data, ...rest } = useQuery(STANDING_OFFERS, {
    variables: { organizationSlug: activeOrganization?.slug || "" },
    skip: !activeOrganization
  });

  const standingOffers =
    data?.organization.__typename === "Organization"
      ? data.organization.standingOffers
      : [];

  return { data: standingOffers, ...rest };
}
